import React from 'react';
import { Check } from 'lucide-react';

const Step7 = ({ data, onSelect, overrides }) => {
  return (
    <div className="flex flex-col">
      {/* Heading */}
      <h1 className="font-serif text-4xl md:text-5xl leading-tight mb-8" style={{ color: '#1a1a2e' }}>
        Many supplements aren't absorbed efficiently — <span className="gradient-text">Hashi-aid</span> is designed for optimal absorption.
      </h1>

      {/* Absorption Illustration Card */}
      <div className="product-card p-8 mb-6">
        {/* Absorption visual */}
        <div className="flex justify-center mb-8">
          <div className="relative">
            {/* Absorption circle */}
            <div 
              className="w-48 h-48 rounded-full border-4 flex items-center justify-center"
              style={{ borderColor: '#7874F8' }}
            >
              {/* Inner absorption visual */}
              <div className="flex flex-col items-center justify-center gap-2">
                {/* Nutrient particles */}
                <div className="flex gap-2 mb-2">
                  <div className="w-3 h-3 rounded-full" style={{ background: 'linear-gradient(135deg, #7874F8 0%, #09C9E9 100%)' }}></div>
                  <div className="w-3 h-3 rounded-full" style={{ background: 'linear-gradient(135deg, #09C9E9 0%, #43B9B2 100%)' }}></div>
                  <div className="w-3 h-3 rounded-full" style={{ background: 'linear-gradient(135deg, #7874F8 0%, #09C9E9 100%)' }}></div>
                </div>
                {/* Arrow down */}
                <div className="flex flex-col items-center">
                  <div className="w-0.5 h-8" style={{ background: 'linear-gradient(180deg, #7874F8 0%, #09C9E9 100%)' }}></div>
                  <div className="w-0 h-0 border-l-4 border-r-4 border-t-8" style={{ borderLeftColor: 'transparent', borderRightColor: 'transparent', borderTopColor: '#09C9E9' }}></div>
                </div>
                {/* Cell representation */}
                <div 
                  className="w-16 h-10 rounded-full mt-2"
                  style={{ 
                    background: 'linear-gradient(180deg, rgba(120, 116, 248, 0.2) 0%, rgba(9, 201, 233, 0.2) 100%)',
                    border: '2px solid #09C9E9'
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>

        {/* Supporting statement */}
        <div className="flex items-start gap-3">
          <div 
            className="w-5 h-5 rounded-full border flex items-center justify-center flex-shrink-0 mt-0.5"
            style={{ borderColor: '#09C9E9' }}
          >
            <Check className="w-3 h-3" style={{ color: '#09C9E9' }} strokeWidth={2.5} />
          </div>
          <span className="text-sm" style={{ color: '#333' }}>
            Bioavailable forms of key thyroid-support nutrients help ensure your body can properly absorb and use them.
          </span>
        </div>
      </div>
    </div>
  );
};

export default Step7;
